import React, { useEffect, useState } from "react";
import { fetchJson, post } from "../../lib/Fetching";
import TopicsInput from "../topics/TopicsInput";

export default function TodoForm({ handleTodoSubmit, clientView }) {
  const [todoText, setTodoText] = useState("");
  const [isShowing, setIsShowing] = useState(false);
  const [topicId, setTopicId] = useState(null);

  function toggle() {
    setIsShowing(!isShowing);
  }

  const onSubmit = (e) => {
    e.preventDefault();
    handleTodoSubmit({
      body: todoText,
      topic_id: topicId,
    }).then(() => setTodoText(""));
  };

  return (
    <div className={"todo-form"}>
      {!isShowing && (
        <button onClick={toggle} className="btn btn-default" style={{ marginBottom: "0px" }}>
          {isShowing ? I18n.t("cancel") : I18n.t("add_todo")}
        </button>
      )}
      {isShowing && (
        <div>
          <form onSubmit={onSubmit}>
            <div className="row">
              <div className="col-md-10">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Describe Todo here..."
                  onChange={(e) => setTodoText(e.target.value)}
                  value={todoText}
                  style={{ width: "100%", marginBottom: "6px" }}
                />
                <TopicsInput
                  multiple={false}
                  value={topicId}
                  onChange={(option) => {
                    setTopicId(option ? option.value : null);
                  }}
                  clientView={clientView}
                  defaultStyle
                />
              </div>
              <div className="col-md-2">
                <button
                  type="submit"
                  className="btn btn-warning btn-block"
                  style={{ marginLeft: "4px", marginBottom: 0 }}
                >
                  {I18n.t("add_todo")}
                </button>
              </div>
            </div>
          </form>
          {clientView && (
            <p className="info">The laboratory staff cannot see the todos you add here.</p>
          )}
          {!clientView && (
            <p className="info">These todos are only visible to laboratory staff.</p>
          )}
        </div>
      )}
    </div>
  );
}
